import { useNavigate } from 'react-router-dom';
import { Avatar, Badge, Button } from '../../../components/ui';
import { Cell, ListPage } from '../../../components/common/ListPage/ListPage';
import { optionsFilter } from '../../../components/common/ListPage/listFilters';
import { labelOf } from '../../../utils/labels';
import { ROLES } from '../../../constants/roles';
import { formatDate } from '../../../utils/date';

export default function TeamList() {
  const navigate = useNavigate();
  const add = <Button leftIcon="plus" onClick={() => navigate('/team/new')}>Add team member</Button>;
  return (
    <ListPage
      title="Team"
      subtitle="Office staff and site workers who can log in"
      path="/users"
      filters={[
        optionsFilter('role', 'Role', ROLES, 'user'),
        { key: 'isActive', label: 'Login', icon: 'checkCircle', options: [{ value: 'true', label: 'Can log in' }, { value: 'false', label: 'Blocked' }] },
      ]}
      searchPlaceholder="Name or phone"
      actions={add}
      rowTo={(u) => `/team/${u._id}/edit`}
      rowActions={(u) => [{ label: 'Edit', icon: 'edit', onClick: () => navigate(`/team/${u._id}/edit`) }]}
      columns={[
        {
          header: 'Name', sort: 'name',
          render: (u) => (
            <span className="flex items-center gap-3">
              <Avatar name={u.name} size={32} />
              <Cell title={u.name} sub={u.email} />
            </span>
          ),
          csv: (u) => u.name,
        },
        { header: 'Phone (login)', sort: 'phone', render: (u) => <span className="tabular">{u.phone}</span>, csv: (u) => u.phone },
        { header: 'Role', sort: 'role', render: (u) => <Badge tone={u.role === 'owner' ? 'blue' : u.role === 'worker' ? 'sky' : 'neutral'}>{labelOf(ROLES, u.role)}</Badge>, csv: (u) => labelOf(ROLES, u.role) },
        { header: 'Last login', sort: 'lastLoginAt', sortDesc: true, render: (u) => (u.lastLoginAt ? formatDate(u.lastLoginAt) : <span className="text-ink-300">Never</span>), csv: (u) => formatDate(u.lastLoginAt) },
        { header: 'Status', sort: 'isActive', render: (u) => (u.isActive ? <Badge tone="green" dot>Active</Badge> : <Badge tone="grey" dot>Blocked</Badge>), csv: (u) => (u.isActive ? 'Active' : 'Blocked') },
      ]}
      mobile={(u) => ({ title: u.name, subtitle: `${labelOf(ROLES, u.role)} · ${u.phone}`, badge: !u.isActive && <Badge tone="grey">Blocked</Badge> })}
      empty={{ icon: 'users', title: 'No team members', action: add }}
    />
  );
}
